module.exports = __webpack_public_path__ + "static/media/2.ce734612.jpg";